<template>
  <div class="w-100 d-flex flex-row" :class="dynamicClass">
    <div :class="[{ 'not-set': isNotSet }]">
      <span v-if="!isNotSet && numberPrefix"> {{ numberPrefix }} </span>
      {{ formattedNumber }}
      <span v-if="!isNotSet && numberSuffix"> {{ numberSuffix }} </span>
    </div>
  </div>
</template>

<script>
import { isNull, isUndefined } from 'lodash'
import { floatToPrecisionString } from '../../../utils'

export default {
  name: 'NumberField',
  props: {
    content: {
      type: [Number, String],
    },
    inDetailView: {
      type: Boolean,
      default: false,
    },
    numberOfDecimals: {
      type: [Number, String],
      default: '0',
    },
    numberPrefix: {
      type: String,
      default: null,
    },
    numberSuffix: {
      type: String,
      default: null,
    },
    thousandSeparated: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dynamicClass() {
      return this.inDetailView || this.isCardView ? 'justify-content-start' : 'justify-content-end'
    },
    locale() {
      const page = document.querySelector('html')
      return page.getAttribute('lang')
    },
    formattedNumber() {
      let precision = parseInt(this.numberOfDecimals)
      if (this.isNotSet) {
        return this.$i18n.t('not_set')
      }
      return floatToPrecisionString(this.content, precision, this.thousandSeparated)
    },
    isCardView() {
      return this.$get('viewMode') === 'cardView'
    },
    isNotSet() {
      return isNull(this.content) || isUndefined(this.content)
    },
    showPrefix() {
      return !this.isNotSet && this.numberPrefix !== null
    },
    showSuffix() {
      return !this.isNotSet && this.numberSuffix !== null
    },
  },
}
</script>

<style lang="scss" scoped>
.not-set {
  color: $color-not-set;
}
</style>
